import { Col, Form, InputNumber, Row, Select } from "antd";
import { useForm } from "antd/es/form/Form";
import React from "react";
import PayrollYearlySettingsService, {
  AEORatesType,
  EmployeePayFrequencyOptionList,
} from "../../Services/PayrollYearlySettingsService";
import { useParams } from "react-router-dom";
import { adminContext } from "../../Common/PageRoute";
import { Utils } from "../../Utilities/Utils";
import SAModal from "../../Common/Custom Components/Ant design/SAModal";

const AddAEORates = ({ onDismiss, itemId, record, aeoRatesType, isViewOnly = false }: any) => {
  const [form] = useForm();
  const { id } = useParams();
  const { openNotification } = React.useContext(adminContext);
  const [loading, setLoading] = React.useState(false);
  var aeoItemType =
    aeoRatesType === AEORatesType.DEAStandard
      ? "AEO Standard rate"
      : aeoRatesType === AEORatesType.DEAHigher
        ? "AEO Higher rate"
        : aeoRatesType === AEORatesType.DEAEAS
          ? "AEO Earnings arrestment scotland rate"
          : aeoRatesType === AEORatesType.DEAMC
            ? "AEO Magistrates court rate"
            : aeoRatesType === AEORatesType.DEACTW
              ? "AEO Council tax wales rate"
              : aeoRatesType === AEORatesType.DEACTE
                ? "AEO Council tax england rate"
                : "";

  React.useEffect(() => {
    if (itemId !== undefined && itemId !== null && itemId !== "") {
      form.setFieldsValue({
        id: record?.id,
        payFrequency: record?.payFrequency,
        rate: record?.rate,
        lowerLimit: record?.lowerLimit,
        higherLimit: record?.higherLimit,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemId, record, aeoRatesType]);
  return (
    <SAModal
      footer={isViewOnly ? null : undefined}
      title={itemId ? `Edit ${aeoItemType} item` : `Add ${aeoItemType} item`}
      width={560}
      open={true}
      okText={"Save"}
      cancelText={"Cancel"}
      okButtonProps={{ loading: loading }}
      onCancel={() => onDismiss(false)}
      onOk={async () => {
        setLoading(true);
        const yearlySettingsRecordId = id ?? "";
        const ItemId = itemId ?? "";
        form.validateFields().then(async (values) => {
          const val = { ...values, id: record?.id }
          let res = await PayrollYearlySettingsService.updateAEORatesItem(
            yearlySettingsRecordId,
            aeoRatesType,
            val,
            ItemId
          );
          if (res.status) {
            openNotification("success", "Details updated successfully");
            onDismiss(true);
            setLoading(false);
          } else {
            openNotification("error", res.message);
            setLoading(false);
          }
        }).catch((error) => {
          setLoading(false);
        });
      }}
    >
      <Form form={form} disabled={isViewOnly} requiredMark={false}>
        <Row gutter={[8, 0]}>
          <Col xs={24} sm={12}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Pay Frequency"
              name="payFrequency"
              rules={[
                {
                  required: true,
                  message: "Select a Pay Frequency",
                },
              ]}
            >
              <Select
                placeholder="Select PayFrequency"
                className="select-height-28"
                options={EmployeePayFrequencyOptionList}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Rate"
              name="rate"
            >
              <InputNumber
                controls={false}
                placeholder="Rate"
                prefix="%"
                onKeyPress={(e) => Utils.ValidatePercentageOnly(e)}
                style={{ width: "100%", height: 28 }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Lower limit"
              name="lowerLimit"
            >
              <InputNumber
                controls={false}
                placeholder="Lower limit"
                prefix="£"
                onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Higher limit"
              name="higherLimit"
            >
              <InputNumber
                controls={false}
                placeholder="Higher limit"
                prefix="£"
                onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </SAModal>
  );
};

export default AddAEORates;
